export const ADMIN_TRANSLATIONS = {
  en: {
    login: {
      title: "Bitakas Admin",
      email: "Email",
      password: "Password",
      signIn: "Sign In",
      signingIn: "Signing in…",
      wrongCredentials: "Wrong email or password.",
    },
    nav: {
      dashboard: "Dashboard",
      users: "Users",
      listings: "Listings",
      reports: "Reports",
      orders: "Orders",
      websiteCMS: "Website CMS",
      heroSlides: "Hero Slides",
      websiteListings: "Website Listings",
      categories: "Categories",
      features: "Features",
      howItWorks: "How It Works",
      faq: "FAQ",
      pricing: "Pricing",
      aboutUs: "About Us",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      signOut: "Sign out",
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Overview of the Bitakas platform",
      seedTitle: "🌱 Seed Default CMS Data",
      seedDesc:
        "Populate hero, categories, features, FAQ and pricing with default content. Run once on first setup.",
      seedBtn: "Seed Defaults",
      seeding: "Seeding…",
      seedConfirm:
        "This will overwrite ALL CMS content with default data. Continue?",
      totalUsers: "Total Users",
      activeListings: "Active Listings",
      openReports: "Open Reports",
      revenue: "Revenue",
      revenueSub: "RevenueCat — Milestone 3",
      recentUsers: "Recent Users",
      colUser: "User",
      colRegion: "Region",
      colJoined: "Joined",
      openReportsTitle: "Open Reports",
      colReported: "Reported",
      colReason: "Reason",
      colDate: "Date",
      noUsers: "No users yet",
      noReports: "✓ No open reports",
    },
    users: {
      title: "Users",
      loaded: "loaded",
      search: "Search name or email…",
      colUser: "User",
      colRegion: "Region",
      colListings: "Listings",
      colTrades: "Trades",
      colStatus: "Status",
      colJoined: "Joined",
      colAction: "Action",
      active: "Active",
      banned: "Banned",
      ban: "Ban",
      unban: "Unban",
      loading: "Loading…",
      noUsers: "No users found",
      loadMore: "Load more",
      bannedMsg: "User banned.",
      unbannedMsg: "User unbanned.",
      banTitle: "Ban",
      banReason: "Reason",
      banPlaceholder: "Reason for ban…",
      cancel: "Cancel",
      confirmBan: "Confirm Ban",
      banning: "Banning…",
      unbanTitle: "Unban",
      unbanBody: "This will restore their access. Reason:",
      confirmUnban: "Unban",
    },
    listings: {
      title: "Listings",
      loaded: "loaded",
      search: "Search listing title…",
      filterAll: "All statuses",
      filterActive: "Active",
      filterTraded: "Traded",
      filterRemoved: "Removed",
      colListing: "Listing",
      colOwner: "Owner",
      colCategory: "Category",
      colRegion: "Region",
      colFeatured: "Featured",
      colStatus: "Status",
      colPosted: "Posted",
      colActions: "Actions",
      removeFeat: "★ Remove",
      addFeat: "☆ Feature",
      remove: "Remove",
      loading: "Loading…",
      loadMore: "Load more",
      confirmRemove: "Remove this listing?",
    },
    reports: {
      title: "Reports",
      count: "reports",
      tabOpen: "open",
      tabResolved: "resolved",
      tabDismissed: "dismissed",
      colReported: "Reported",
      colReason: "Reason",
      colReporter: "Reporter",
      colDate: "Date",
      colActions: "Actions",
      review: "Review",
      dismiss: "Dismiss",
      resolve: "Resolve",
      banResolve: "Ban & Resolve",
      cancel: "Cancel",
      reviewTitle: "Review Report",
      reportedLabel: "Reported:",
      reasonLabel: "Reason:",
      resolutionLabel: "Resolution note",
      resolutionPlaceholder: "Optional resolution note…",
      resolvedMsg: "Report resolved.",
      dismissedMsg: "Report dismissed.",
      noReports: "reports",
    },
    orders: {
      title: "Trade Orders",
      completed: "completed trades",
      search: "Search by Order ID or item…",
      colOrderId: "Order ID",
      colSender: "Sender",
      colItem: "Offered Item",
      colFor: "For Listing",
      colCash: "Cash",
      colCompleted: "Completed",
      fairTrade: "Fair trade",
      loading: "Loading…",
      noOrders: "No orders yet",
    },
    cms: {
      save: "Save Changes",
      saving: "Saving…",
      langEN: "🇬🇧 English",
      langTR: "🇹🇷 Turkish",
      remove: "✕",
      confirmRemove: "Remove this item?",
    },
    cmsHero: {
      title: "Hero Slides",
      subtitle: "Manage banner slides shown on the website homepage.",
      addSlide: "+ Add Slide",
      save: "Save Changes",
      saved: "Hero saved!",
      fieldTitle: "Title",
      fieldCta: "CTA Button",
      fieldSubtitle: "Subtitle",
      fieldCtaLink: "CTA Link",
      fieldImage: "Slide Image",
      changeImage: "Change image",
      uploadImage: "Upload image",
      imageHint: "📷 Click to upload (1920×640px recommended)",
      noSlides: "No slides yet — click Add Slide",
    },
    cmsCategories: {
      title: "Categories",
      subtitle: "Manage the categories section displayed on the website.",
      addBtn: "+ Add Category",
      saved: "Categories saved!",
      fieldIcon: "Icon (emoji)",
      fieldLabel: "Label",
      fieldColor: "Accent Colour",
      preview: "Preview",
      noItems: "No categories yet — click Add Category",
    },
    cmsFeatures: {
      title: "App Features",
      subtitle:
        "Manage the features section that shows why users should choose Bitakas.",
      addBtn: "+ Add Feature",
      saved: "Features saved!",
      fieldIcon: "Icon",
      fieldTitle: "Title",
      fieldDesc: "Description",
      noItems: "No features yet — click Add Feature",
      searchIcons: "Search icon name…",
      selectIcon: "Select an icon…",
    },
    cmsHowItWorks: {
      title: "How It Works",
      subtitle: "Edit the step-by-step guide shown on the website.",
      addBtn: "+ Add Step",
      saved: "How It Works saved!",
      stepLabel: "Step",
      fieldTitle: "Title",
      fieldDesc: "Description",
      noItems: "No steps yet — click Add Step",
    },
    cmsFaq: {
      title: "FAQ",
      subtitle: "Edit frequently asked questions shown on the website.",
      addBtn: "+ Add Question",
      saved: "FAQ saved!",
      fieldQ: "Question",
      fieldA: "Answer",
      noItems: "No questions yet — click Add Question",
    },
    cmsPricing: {
      title: "Pricing Plans",
      subtitle:
        "Manage subscription tiers. Feature lines are entered one per line.",
      addBtn: "+ Add Plan",
      saved: "Pricing saved!",
      highlighted: "Highlighted",
      fieldName: "Plan Name",
      fieldPrice: "Price",
      fieldInterval: "Billing Interval",
      monthly: "Monthly",
      yearly: "Yearly",
      free: "Free (no billing)",
      fieldCta: "CTA Button",
      fieldFeatures: "Features (one per line)",
      preview: "Preview",
      popular: "★ MOST POPULAR",
      mo: "mo",
      yr: "yr",
      noItems: "No plans yet — click Add Plan",
    },
    cmsWebListings: {
      title: "Website Listings",
      subtitle:
        "Pick which app listings appear on the website homepage as a photo gallery. Only the image is shown — no text.",
      allListings: "All App Listings",
      onWebsite: "On Website",
      empty: "Click any listing on the left to add it here",
      search: "Search…",
      loadMore: "Load more listings",
      save: "Save",
      reorderHint: "Drag ▲▼ to reorder how they appear on the website",
    },
    cmsPage: {
      subtitle:
        "Sections render top-to-bottom on the public page. URLs and emails in content are auto-linked.",
      addSection: "+ Add Section",
      savePage: "Save Page",
      saved: "Saved!",
      typeSection: "Section heading",
      typeSubsection: "Subsection heading",
      typeParagraph: "Paragraph only",
      headingSection: "Section Heading",
      headingSubsection: "Subsection Heading",
      content: "Content",
      contentHint: "— URLs and emails are auto-linked",
      contentPlaceholder:
        "Enter content… https://links.com and email@example.com are clickable automatically.",
      removeBtn: "Remove",
      confirmRemove: "Remove this section?",
      noSections:
        "No sections yet — click Add Section to start building the page.",
    },
    termsTitle: "Terms & Conditions",
    privacyTitle: "Privacy Policy",
    aboutTitle: "About Us",
  },

  tr: {
    login: {
      title: "Bitakas Yönetim",
      email: "E-posta",
      password: "Şifre",
      signIn: "Giriş Yap",
      signingIn: "Giriş yapılıyor…",
      wrongCredentials: "Hatalı e-posta veya şifre.",
    },
    nav: {
      dashboard: "Gösterge Paneli",
      users: "Kullanıcılar",
      listings: "İlanlar",
      reports: "Şikayetler",
      orders: "Siparişler",
      websiteCMS: "Web Sitesi CMS",
      heroSlides: "Anasayfa Slider",
      websiteListings: "Site İlanları",
      categories: "Kategoriler",
      features: "Özellikler",
      howItWorks: "Nasıl Çalışır",
      faq: "SSS",
      pricing: "Fiyatlandırma",
      aboutUs: "Hakkımızda",
      terms: "Kullanım Koşulları",
      privacy: "Gizlilik Politikası",
      signOut: "Çıkış Yap",
    },
    dashboard: {
      title: "Gösterge Paneli",
      subtitle: "Bitakas platformuna genel bakış",
      seedTitle: "🌱 Varsayılan CMS Verisi Yükle",
      seedDesc:
        "Hero slider, kategoriler, özellikler, SSS ve fiyatlandırmayı varsayılan içerikle doldurun. Yalnızca ilk kurulumda çalıştırın.",
      seedBtn: "Varsayılanları Yükle",
      seeding: "Yükleniyor…",
      seedConfirm:
        "Bu işlem TÜM CMS içeriğini varsayılan verilerle değiştirecek. Devam edilsin mi?",
      totalUsers: "Toplam Kullanıcı",
      activeListings: "Aktif İlan",
      openReports: "Açık Şikayet",
      revenue: "Gelir",
      revenueSub: "RevenueCat — 3. Aşama",
      recentUsers: "Son Kullanıcılar",
      colUser: "Kullanıcı",
      colRegion: "Bölge",
      colJoined: "Katılım",
      openReportsTitle: "Açık Şikayetler",
      colReported: "Şikayet Edilen",
      colReason: "Sebep",
      colDate: "Tarih",
      noUsers: "Henüz kullanıcı yok",
      noReports: "✓ Açık şikayet yok",
    },
    users: {
      title: "Kullanıcılar",
      loaded: "yüklendi",
      search: "Ad veya e-posta ara…",
      colUser: "Kullanıcı",
      colRegion: "Bölge",
      colListings: "İlan",
      colTrades: "Takas",
      colStatus: "Durum",
      colJoined: "Katılım",
      colAction: "İşlem",
      active: "Aktif",
      banned: "Engellendi",
      ban: "Engelle",
      unban: "Engeli Kaldır",
      loading: "Yükleniyor…",
      noUsers: "Kullanıcı bulunamadı",
      loadMore: "Daha fazla yükle",
      bannedMsg: "Kullanıcı engellendi.",
      unbannedMsg: "Kullanıcının engeli kaldırıldı.",
      banTitle: "Engelle",
      banReason: "Sebep",
      banPlaceholder: "Engelleme sebebi…",
      cancel: "İptal",
      confirmBan: "Engeli Onayla",
      banning: "Engelleniyor…",
      unbanTitle: "Engeli Kaldır",
      unbanBody: "Bu işlem kullanıcının erişimini geri yükleyecek. Sebep:",
      confirmUnban: "Engeli Kaldır",
    },
    listings: {
      title: "İlanlar",
      loaded: "yüklendi",
      search: "İlan başlığı ara…",
      filterAll: "Tüm durumlar",
      filterActive: "Aktif",
      filterTraded: "Takas Edildi",
      filterRemoved: "Kaldırıldı",
      colListing: "İlan",
      colOwner: "Sahip",
      colCategory: "Kategori",
      colRegion: "Bölge",
      colFeatured: "Öne Çıkan",
      colStatus: "Durum",
      colPosted: "Tarih",
      colActions: "İşlemler",
      removeFeat: "★ Kaldır",
      addFeat: "☆ Öne Çıkar",
      remove: "Kaldır",
      loading: "Yükleniyor…",
      loadMore: "Daha fazla yükle",
      confirmRemove: "Bu ilan kaldırılsın mı?",
    },
    reports: {
      title: "Şikayetler",
      count: "şikayet",
      tabOpen: "açık",
      tabResolved: "çözümlendi",
      tabDismissed: "reddedildi",
      colReported: "Şikayet Edilen",
      colReason: "Sebep",
      colReporter: "Şikayet Eden",
      colDate: "Tarih",
      colActions: "İşlemler",
      review: "İncele",
      dismiss: "Reddet",
      resolve: "Çözümle",
      banResolve: "Engelle & Çözümle",
      cancel: "İptal",
      reviewTitle: "Şikayeti İncele",
      reportedLabel: "Şikayet Edilen:",
      reasonLabel: "Sebep:",
      resolutionLabel: "Çözüm notu",
      resolutionPlaceholder: "İsteğe bağlı çözüm notu…",
      resolvedMsg: "Şikayet çözümlendi.",
      dismissedMsg: "Şikayet reddedildi.",
      noReports: "şikayet",
    },
    orders: {
      title: "Takas Siparişleri",
      completed: "tamamlanan takas",
      search: "Sipariş No veya ürün ara…",
      colOrderId: "Sipariş No",
      colSender: "Gönderen",
      colItem: "Teklif Edilen Ürün",
      colFor: "Karşılığında",
      colCash: "Nakit",
      colCompleted: "Tamamlandı",
      fairTrade: "Eşit takas",
      loading: "Yükleniyor…",
      noOrders: "Henüz sipariş yok",
    },
    cms: {
      save: "Değişiklikleri Kaydet",
      saving: "Kaydediliyor…",
      langEN: "🇬🇧 İngilizce",
      langTR: "🇹🇷 Türkçe",
      remove: "✕",
      confirmRemove: "Bu öğe kaldırılsın mı?",
    },
    cmsHero: {
      title: "Anasayfa Slider",
      subtitle:
        "Web sitesi anasayfasında gösterilen banner slaytlarını yönetin.",
      addSlide: "+ Slayt Ekle",
      save: "Değişiklikleri Kaydet",
      saved: "Slider kaydedildi!",
      fieldTitle: "Başlık",
      fieldCta: "CTA Butonu",
      fieldSubtitle: "Alt Başlık",
      fieldCtaLink: "CTA Bağlantısı",
      fieldImage: "Slayt Görseli",
      changeImage: "Görseli değiştir",
      uploadImage: "Görsel yükle",
      imageHint: "📷 Yüklemek için tıklayın (önerilen: 1920×640px)",
      noSlides: "Henüz slayt yok — Slayt Ekle'ye tıklayın",
    },
    cmsCategories: {
      title: "Kategoriler",
      subtitle:
        "Web sitesi anasayfasında gösterilen kategoriler bölümünü yönetin.",
      addBtn: "+ Kategori Ekle",
      saved: "Kategoriler kaydedildi!",
      fieldIcon: "İkon (emoji)",
      fieldLabel: "Etiket",
      fieldColor: "Vurgu Rengi",
      preview: "Önizleme",
      noItems: "Henüz kategori yok — Kategori Ekle'ye tıklayın",
    },
    cmsFeatures: {
      title: "Uygulama Özellikleri",
      subtitle:
        "Kullanıcıların neden Bitakas'ı seçmesi gerektiğini gösteren bölümü yönetin.",
      addBtn: "+ Özellik Ekle",
      saved: "Özellikler kaydedildi!",
      fieldIcon: "İkon",
      fieldTitle: "Başlık",
      fieldDesc: "Açıklama",
      noItems: "Henüz özellik yok — Özellik Ekle'ye tıklayın",
      searchIcons: "İkon adı ara…",
      selectIcon: "Bir ikon seçin…",
    },
    cmsHowItWorks: {
      title: "Nasıl Çalışır",
      subtitle: "Web sitesinde gösterilen adım adım kılavuzu düzenleyin.",
      addBtn: "+ Adım Ekle",
      saved: "Nasıl Çalışır kaydedildi!",
      stepLabel: "Adım",
      fieldTitle: "Başlık",
      fieldDesc: "Açıklama",
      noItems: "Henüz adım yok — Adım Ekle'ye tıklayın",
    },
    cmsFaq: {
      title: "SSS",
      subtitle: "Web sitesinde gösterilen sık sorulan soruları düzenleyin.",
      addBtn: "+ Soru Ekle",
      saved: "SSS kaydedildi!",
      fieldQ: "Soru",
      fieldA: "Cevap",
      noItems: "Henüz soru yok — Soru Ekle'ye tıklayın",
    },
    cmsPricing: {
      title: "Fiyatlandırma Planları",
      subtitle:
        "Fiyatlandırma bölümündeki abonelik kademelerini yönetin. Özellikler her satıra bir tane girilir.",
      addBtn: "+ Plan Ekle",
      saved: "Fiyatlandırma kaydedildi!",
      highlighted: "Öne Çıkan",
      fieldName: "Plan Adı",
      fieldPrice: "Fiyat",
      fieldInterval: "Faturalama Periyodu",
      monthly: "Aylık",
      yearly: "Yıllık",
      free: "Ücretsiz (faturalama yok)",
      fieldCta: "CTA Butonu",
      fieldFeatures: "Özellikler (her satıra bir tane)",
      preview: "Önizleme",
      popular: "★ EN POPÜLER",
      mo: "ay",
      yr: "yıl",
      noItems: "Henüz plan yok — Plan Ekle'ye tıklayın",
    },
    cmsWebListings: {
      title: "Site İlanları",
      subtitle:
        "Web sitesi anasayfasında fotoğraf galerisi olarak görünecek ilanları seçin. Yalnızca görsel gösterilir — metin yok.",
      allListings: "Tüm Uygulama İlanları",
      onWebsite: "Web Sitesinde",
      empty: "Eklemek için soldaki herhangi bir ilana tıklayın",
      search: "Ara…",
      loadMore: "Daha fazla ilan yükle",
      save: "Kaydet",
      reorderHint: "Sıralamak için ▲▼ kullanın",
    },
    cmsPage: {
      subtitle:
        "Bölümler, herkese açık sayfada yukarıdan aşağıya doğru sıralanır. İçerikteki URL ve e-postalar otomatik bağlantıya dönüşür.",
      addSection: "+ Bölüm Ekle",
      savePage: "Sayfayı Kaydet",
      saved: "Kaydedildi!",
      typeSection: "Bölüm başlığı",
      typeSubsection: "Alt bölüm başlığı",
      typeParagraph: "Yalnızca paragraf",
      headingSection: "Bölüm Başlığı",
      headingSubsection: "Alt Bölüm Başlığı",
      content: "İçerik",
      contentHint: "— URL'ler ve e-postalar otomatik bağlantıya dönüşür",
      contentPlaceholder:
        "İçerik girin… https://links.com ve email@example.com otomatik tıklanabilir olur.",
      removeBtn: "Kaldır",
      confirmRemove: "Bu bölüm kaldırılsın mı?",
      noSections:
        "Henüz bölüm yok — Sayfayı oluşturmak için Bölüm Ekle'ye tıklayın.",
    },
    termsTitle: "Kullanım Koşulları",
    privacyTitle: "Gizlilik Politikası",
    aboutTitle: "Hakkımızda",
  },
};
